<template>
  <div>
    <form-wizard 
      color="#0080C9" 
      :title="null" 
      :subtitle="null" 
      layout="horinzotal" 
      finish-button-text="Crear"
      back-button-text="Retroceder" 
      next-button-text="Siguiente" 
      class="wizard-vertical mb-3"
      @on-complete="formSubmittedCita"
    >
      <template v-slot:footer="props">
        <div class="wizard-footer-left">
          <b-button 
            v-if="props.activeTabIndex > 0" 
            :style="props.fillButtonStyle" 
            @click="props.prevTab()"
            class="wizard-button" variant="primary">
            Atras
          </b-button>
        </div>

        <div class="wizard-footer-right">
          <b-button 
            v-if="!props.isLastStep" 
            @click="props.nextTab()" variant="primary"
            class="wizard-button" :style="props.fillButtonStyle"
          >
            Siguiente
          </b-button>

          <b-button 
            v-if="props.isLastStep" 
            @click="formSubmittedCita()" 
            variant="primary" 
            class="wizard-button"
            :style="props.fillButtonStyle" :disabled="isSubmitting"
          >
            Finalizar
          </b-button>
        </div>

      </template>

      <tab-content 
        title="Información de la Cita." 
        :before-change="validationDataCita"
      >
        <CitaInfo ref="formDataCita"/>
      </tab-content>


      <tab-content 
        v-if="canViewTabSeguros"
        title="Cobertura/Titulares" 
        :before-change="validationFormCobertura"
      >
        <CitaCobertura ref="formDataCobertura"/>
      </tab-content>


      <tab-content 
        title="Documentos"
        :before-change="validationFormDocumentos"
      >
        <DocumentosCita ref="documentosCitaRef"/>
      </tab-content>


      <tab-content
        v-if="canViewTabServicios"
        title="Servicios"
        :before-change="validationEnvioServicios"
      >
        <CrearImagenesDerivadas v-if="canSendImagenes"/>
        <CrearLaboratoriosDerivados v-if="canSendLaboratorios"/>
        <CrearProcedimientosDerivados v-if="canSendProcedimientos"/>
      </tab-content>


      <tab-content
        v-if="verTabEncuesta"
        title="Encuesta/Finalizar"
      >

        <b-container fluid class="d-flex justify-content-center align-items-center ">
          <b-row>
            <b-col>
              <div v-if="!encuesta" class="bg-primary p-2">
                <h4 class=" text-white">
                  Ingrese una calificación (1 - 4):
                </h4>

                <b-form-input 
                  class="mt-2 p-2" 
                  autofocus size="md" 
                  :type="inputType" 
                  v-model="encuesta"
                  @keydown="validateKey"
                />
              </div>
              
              <div v-if="encuesta" class="bg-success p-2">
                <h4 class=" text-white">
                  Encuesta realizada!
                  <i class="fa-solid fa-check-to-slot"></i>
                  <i class="fa-solid fa-check-to-slot"></i>
                  <i class="fa-solid fa-check-to-slot"></i>
                </h4>

              </div>
            </b-col>
          </b-row>
        </b-container>

      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import { personasService, pacientesService }        from "@/views/admision/services";
import {  doctoresService }       from "@/views/administracion/services";
import { imagenesService }        from '@/views/imagen/services';
import Swal from 'sweetalert2'
import { mapState } from 'vuex';
import "flatpickr/dist/flatpickr.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import { fileService } from "@/shared/services";

import {
  BRow,
  BCol,
  BButton,
  BFormInput,

} from "bootstrap-vue";


import rutas from "@/assets/utils/rutas.json";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "axios";
import { MEDICO_DERIVACIONES, ROLES }    from "@/shared/constants";
import CitaCobertura              from "@/views/citas/components/RegistrarCitas/CitaCobertura.vue";
import { DocumentosCita }             from '@/views/citas/components';
import { formatDateToDB, getEstablecimientoLS } from "@/shared/helpers";
import { derivacionesService  } from '@/views/derivaciones/services';

import CrearImagenesDerivadas     from "../components/RegistrarCitas/CrearImagenesDerivadas.vue";
import CrearLaboratoriosDerivados from "../components/RegistrarCitas/CrearLaboratoriosDerivados.vue";
import CrearProcedimientosDerivados from "../components/RegistrarCitas/CrearProcedimientosDerivados.vue";

import { citasService } from "../services";
import { labAs400Service, labAuxiliarService } from "../../laboratorio/services";
import { procedimientosService } from "../../procesoclinico/services";
import CitaInfo from "../components/RegistrarCitas/CitaInfo.vue";
import { calculateAgeWithDateString } from "../../../shared/helpers";

const ALLOWED_ROLES_EDIT_FECHA = [ROLES.JEFE_MEDICO, ROLES.JEFE_VALIDACIONES];


export default {
  components: {
    CrearImagenesDerivadas,
    CrearLaboratoriosDerivados,
    CrearProcedimientosDerivados,

    FormWizard,
    TabContent,
    BRow,
    BButton,
    BCol,
    BFormInput,
    CitaCobertura,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,

    CitaInfo,
    DocumentosCita
  },


  data() {
    return {

      verTabEncuesta: false,

      flagLoadRespaldo:false,
      doctoresService,
      encuesta: null,
      isSubmitting: false,
      processList: [],

      //
      inputType: "number",
      tiposContingencia: [],
      date: null,
      paciente: null,
      doctor: null,
      estadoCita: null,
      itemsti: [],
      urlsMspPaciente: null,
      urlsMspTitular: null,
      horaCita: null,
      estabsalud: null,

      config: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
      },

      citaRepetida: false,
      searchKeyword: "",
      debounceTimeout: null,
      generar: true,
      
      fechaCita: null,
      usuarioRoles: [],
      codG: [
        '0000000001', '0000000013', '0000000012', '0000000017', '0000000018', '0000000019', '0000000020'
      ],
      idEstablecimiento: '',
    };
  },


  async created() {

    await this.resetStateRegistrarCita();
    await this.obtenerUserDetails()
    this.setToken();
  },

  methods: {


    resetStateRegistrarCita(){
      this.$store.commit("resetStateRegistrarCita");
    },

    obtenerHoraActual() {
      const ahora = new Date();
      const horas = String(ahora.getHours()).padStart(2, '0');
      const minutos = String(ahora.getMinutes()).padStart(2, '0');
      const segundos = String(ahora.getSeconds()).padStart(2, '0');
      return `${horas}:${minutos}:${segundos}`;
    },


    async obtenerUserDetails() {
      const dataUsuario = localStorage.getItem('detalleusuario');
      if(!dataUsuario) return;

      try {
        const user = JSON.parse(dataUsuario);
        this.usuarioRoles = Array.isArray(user.roles) ? user.roles : [];

        const establecimiento = user.establecimiento;
        this.idEstablecimiento = establecimiento ? establecimiento.id : "";
        this.estabsalud = establecimiento ? { value: establecimiento.id, text: establecimiento.Descripcion } : "";

        this.usuarioRoles.forEach(i => {
          if (this.codG.includes(i.codigo))
            this.idEstablecimiento = '0'
        });

      } catch (error) {
        console.error('Error al obtener detalle del usuario', error);
        this.usuarioRoles = [];
      }
    },


    async validationFormCobertura() {
      
      const codsCoberturaConTitular = ['AG', 'CA', 'CJ', 'CY', 'HJ', 'MH', 'MO', 'AS'];
      const errores = [];

      const seguroSalud        = this.stDataSeguro?.seguroSalud?.code;
      const numHistoriaClinica = this.stDataSeguro?.historiaClinica;

      const titulares = this.stDataTitulares;

      if(!seguroSalud){
        errores.push("Debe seleccionar un seguro de salud");
      }

      if(!titulares.length && codsCoberturaConTitular.includes(seguroSalud)){
        errores.push("Debe agregar un titular");
      }


      if(titulares.length && codsCoberturaConTitular.includes(seguroSalud)){

        const hayPadreSoltero = titulares.some( t => t.padreSoltero)
        const algunoDaCobertura = titulares.some( t => t.daCobertura)

        if(titulares.length === 1 && !hayPadreSoltero && this.esMenorDeEdad){
          errores.push("Debe agregar otro titular");
        }

        if(titulares.length && !algunoDaCobertura){
          errores.push("Al menos un titular debe dar cobertura");
        }
      }

      if (errores.length > 0) {
        const mensajeError = errores.join('\n');
        await this.$swal.fire({
          title: 'Datos incompletos!',
          icon: 'error',
          text: mensajeError
        });
        throw new Error("Validación fallida");
      }

      return true;
    },


    validationFormDocumentos(){
      return this.$refs.documentosCitaRef.validationFormDocumentos();
    },


    validationDataCita() {
      return this.$refs.formDataCita.validationDataCita();
    },


    async validationEnvioServicios() {
      const errores = [];

      if(this.tipoServicio.includes('2') && !this.stDataEnvioImagenes?.length)
        errores.push("Debe agregar una imagen");

      if(this.tipoServicio.includes('3'))
        if(!this.stDataEnvioLaboratorios?.length && !this.stDataEnvioLabs400?.length)
          errores.push("Debe agregar un laboratorio");

      if(this.tipoServicio.includes('4') && !this.stDataEnvioProcedimientos?.length)
        errores.push("Debe agregar un procedimiento");
      

      if(!errores.length) return true;

      await this.$swal.fire({
        title: 'Datos incompletos!',
        icon: 'error',
        text: errores
      });

      return false; 
    },

    async validationEnvioImagen() {

      const errores = [];

      if(!this.stDataEnvioImagenes?.length)
        errores.push("Debe agregar una imagen");
      
      if(!errores.length) return true;

      await this.$swal.fire({
        title: 'Datos incompletos!',
        icon: 'error',
        text: errores
      });

      return false;      
    },


    async validationEnvioLaboratorio(){

      const errores = [];

      if(!this.stDataEnvioLaboratorios?.length)
        errores.push("Debe agregar un laboratorio");

      if(!errores.length) return true;

      await this.$swal.fire({
        title: 'Datos incompletos!',
        icon: 'error',
        text: errores
      });
      
      return false;
    },


    async validationEnvioProcesos(){

      const errores = [];

      if(!this.stDataEnvioProcedimientos?.length)
        errores.push("Debe agregar procesos");

      if(!errores.length) return true;

      await this.$swal.fire({
        title: 'Datos incompletos!',
        icon: 'error',
        text: errores
      });
      
      return false;
    },


    async validationFormEncuesta() {
      
      if (!this.encuesta) {
        await this.$swal.fire({
          title: 'Datos incompletos!',
          icon: 'error',
          text: 'Validación encuesta fallida'
        });

        return false;
      }

      return true;
    },


    async fetchCitaCreada(idDoctor, idPaciente) {
      const query = `
        query MyQuery($pacienteId :ID , $doctorId :ID) {
          allCitas(pacienteId: $pacienteId, doctorId: $doctorId) {
            cita {
              horaCita
              fechaCita
            }
          }
        }`;

      const variables = {
        pacienteId: idPaciente,
        doctorId: idDoctor
      }

      try {

        const response = await axios.post(rutas.axios + "api", { query, variables });
        if (response.data.data.allCitas.cita.length > 0) {
          return response.data.data.allCitas.cita
        } else { return [] }

      } catch (error) {
        console.log(`Existe un error ${error}`);
        return null;
      }
    },



    async formSubmittedCita() {

      if(!this.tokenCita){
        const isEncuestaValida = await this.validationFormEncuesta();
        if (!isEncuestaValida) return;
      }

      if(this.esOtrosServicios){
        const validationOtrosServicios = await this.validationEnvioServicios();
        if (!validationOtrosServicios) return;
      }

      if (this.isSubmitting) return;
      this.isSubmitting = true;

      let timerInterval;
      Swal.fire({
        title: 'Guardando...',
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(() => {
            const timer = Swal.getTimerLeft();
            if (timer) {
              Swal.getContent().querySelector("b").textContent = `${timer}`;
            }
          }, 100);
        },
        
        willClose: () => {
          clearInterval(timerInterval);
        }
      });

      try {
        
        const citaId = await this.crearCita();

        if(citaId) await this.crearDetailsCita(citaId);

        if(citaId && this.esOtrosServicios) await this.crearOtrosServicios(citaId);

        if(citaId) await this.updateDocsPersonas();

        if(citaId  && this.esCoberturaIess) await this.updateHistoriaClinica(citaId);

        Swal.close();

        if(citaId){
          this.isSubmitting = false;

          console.log('procesos', this.processList);

          await this.$swal({
            title: this.tokenCita ? 'Cita Actualizada' : 'Cita Creada',
            icon: 'success',
            confirmButtonColor: '#089599',
          });

          localStorage.removeItem('respaldoCita');
          this.$router.push({ name: 'consultar_citas' })
        }
        
      } catch (err) {
        this.isSubmitting = false
        console.log('este es el error', err)
        
      }
    },


    async crearCita() {

      const nIdentificacion      = this.stDataCita.paciente?.persona.identificacion;
      const servicioSeleccionado = this.tipoServicio
      let establecimientoId      = getEstablecimientoLS().id;
      let fechaIngreso           = formatDateToDB(new Date());

      let estadoActual = this.stDataCita?.estadoActual ?? '1';
      let estadoCita   = this.stDataCita?.estadoCita   ?? '1';
      let estadoRevision = this.stDataCita?.estadoRevision ?? '1';
      let doctor              = null;
      let horaCita            = null;
      let tipoContingencia    = null;
      let estadoSignosVitales = null;

      if(this.tokenCita){
        if(this.stDataCita?.fechaIngreso) fechaIngreso = this.stDataCita.fechaIngreso;
        if(this.stDataCita?.establecimientoId) establecimientoId = this.stDataCita.establecimientoId;
      }

      if(servicioSeleccionado.includes('1')){
        doctor   = this.stDataCita.doctor.id;
        horaCita = this.stDataCita.horaCita;
        tipoContingencia = this.stDataCita.tipoContingencia?.value || '';
        estadoSignosVitales = this.stDataCita?.estadoSignosVitales ?? '0';
      }

      if(this.esOtrosServicios){
        doctor = MEDICO_DERIVACIONES.IMAGENES;
        horaCita = this.obtenerHoraActual();
        tipoContingencia = '1';
        estadoSignosVitales = '1';
        estadoActual = '3'

      }
      let newUrlMspPaciente = null;
      let newUrlMspTitular1 = null;
      let newUrlMspTitular2 = null;
      let newUrlMspTitular3 = null;

      // cargar archivos
      const filesCita = this.stDataDocumentos?.cita;

      if(filesCita){

        if(filesCita?.mspPaciente){
          newUrlMspPaciente = await fileService.upload(
            'msp', 
            filesCita.mspPaciente,
            nIdentificacion,
            filesCita.urlMspPaciente
          );
        }

        if(filesCita?.mspPaciente === undefined){
          const deleteFile = await fileService.deleteFile(filesCita.urlMspPaciente);
          newUrlMspPaciente = deleteFile ? 'eliminado' : ''
        }


        if(filesCita?.mspTitular1){
          newUrlMspTitular1 = await fileService.upload(
            'msp', 
            filesCita.mspTitular1,
            nIdentificacion,
            filesCita.urlMspTitular1
          );
        }

        if(filesCita?.mspTitular1 === undefined){
          const deleteFile = await fileService.deleteFile(filesCita.urlMspTitular1);
          newUrlMspTitular1 = deleteFile ? 'eliminado' : ''
        }

        if(filesCita?.mspTitular2){
          newUrlMspTitular2 = await fileService.upload(
            'msp', 
            filesCita.mspTitular2,
            nIdentificacion,
            filesCita.urlMspTitular2
          );
        }

        if(filesCita?.mspTitular2 === undefined){
          const deleteFile = await fileService.deleteFile(filesCita.urlMspTitular2);
          newUrlMspTitular2 = deleteFile ? 'eliminado' : ''
        }


        if(filesCita?.mspTitular3){
          newUrlMspTitular3 = await fileService.upload(
            'msp', 
            filesCita.mspTitular3,
            nIdentificacion,
            filesCita.urlMspTitular3
          );
        }

        if(filesCita?.mspTitular3 === undefined){
          const deleteFile = await fileService.deleteFile(filesCita.urlMspTitular3);
          newUrlMspTitular3 = deleteFile ? 'eliminado' : ''
        }

      } 
    

      const urlDerivacion = filesCita?.derivacion
        ? await fileService.upload('derivacion', filesCita.derivacion, nIdentificacion)
        : null;

      const urlCodigoDerivacion = filesCita?.tirilla
        ? await fileService.upload('tirrillaDerivacion', filesCita.tirilla, nIdentificacion)
        : null;


      const url007Recibido = filesCita?.f007
        ? await fileService.upload('f007', filesCita.f007, nIdentificacion)
        : null;

      const urlSolImgDer   = filesCita?.solicitudImagen
        ? await fileService.upload('solicitudImagen', filesCita.solicitudImagen, nIdentificacion)
        : null;

      const urlSolLabDer   = filesCita?.solicitudLaboratorio
        ? await fileService.upload('solicitudLaboratorio', filesCita.solicitudLaboratorio, nIdentificacion)
        : null;

      const urlSolProcDer  = filesCita?.solicitudProcedimiento
        ? await fileService.upload('solicitudProcedimiento', filesCita.solicitudProcedimiento, nIdentificacion)
        : null;

      const urlOtrosDocumentos = filesCita?.otrosDocs
        ? await fileService.upload('otrosDocs', filesCita.otrosDocs, nIdentificacion)
        : null;
      

      const variables = {
        paciente        : this.stDataCita.paciente.id,
        doctor          : doctor,
        estadoCita      : estadoCita,
        estadoActual    : estadoActual,
        horaCita        : horaCita,
        derivacion      : this.stDataCita.esDerivado ? 1 : 0,
        codderivacion   : this.stDataCita.codigoDerivacion || "",
        fecderivacion   : this.stDataCita.fechaDerivacion  || "",
        fecfinderivacion: this.stDataCita.fechaFinDerivacion || "",
        fechaIngreso    : fechaIngreso,

        urlMspPaciente  : newUrlMspPaciente   || "",
        urlMspTitular1  : newUrlMspTitular1   || "",
        urlMspTitular2  : newUrlMspTitular2   || "",
        urlMspTitular3  : newUrlMspTitular3   || "",
        urlDerivacion   : urlDerivacion       || "",
        urlCodigoDer    : urlCodigoDerivacion || "",
        url007Recibido  : url007Recibido      || "",

        urlSolLabDer    : urlSolLabDer        || "",
        urlSolImgDer    : urlSolImgDer        || "",
        urlSolProcDer   : urlSolProcDer       || "",

        urlOtrosDocumentos : urlOtrosDocumentos || "",

        cobSeleccionada : this.stDataCita.cobertura || null,
        encuesta        : this.encuesta,
        establecimiento : establecimientoId,
        tipoContingencia: tipoContingencia,
        segderivacion   : this.stDataCita.cobertura,
        tipoServicios   : servicioSeleccionado ? JSON.stringify(servicioSeleccionado) : null,
        estadoRevision  : estadoRevision,
      };

      if(this.tokenCita && this.canUpdateFechaCita && this.stDataCita.fechaCita){
        variables.fechaCita = this.stDataCita.fechaCita;
      }


      const responseCrearCita = this.tokenCita 
        ? await citasService.updateByToken(this.tokenCita, variables)
        : await citasService.crearRegistro(variables);

      this.processList.push({ text:"Cita guardada", value: responseCrearCita });
      return responseCrearCita?.id;
    },


    async crearDetailsCita(citaId) {

      const titulares   = this.stDataTitulares || [];
      const segurosCita = this.stDataSeguro;
      const docsPersonas = this.stDataDocumentos?.personas || [];
      const arrayUrls = docsPersonas.map(persona => ({
        idPersona: persona.idPersona,
        url_cedula: persona.urlIdentificacion || '',
        url_carnet: persona.urlCarnetIssfa || persona.urlCarnetIsspol || ''
      }));

      const dataDetalles = {
        cita        : citaId,
        titulares   : titulares.length ? JSON.stringify(titulares) : '[]',
        segurosCita : segurosCita ? JSON.stringify(segurosCita) : null,
        arrayUrls   : JSON.stringify(arrayUrls)
      };

      let responseSave = null;

      if (this.tokenCita) {
        const responseCita = await citasService.getByToken(this.tokenCita);
        const idCitaDetails = responseCita?.detallescitaSet?.[0]?.id;

        responseSave = idCitaDetails
          ? await citasService.actualizarDetalles({
            idCitaDetails,
            titulares: dataDetalles.titulares,
            segurosCita: dataDetalles.segurosCita,
            arrayUrls: dataDetalles.arrayUrls
          })
          : await citasService.guardarDetalles(dataDetalles);
      } else {
        responseSave = await citasService.guardarDetalles(dataDetalles);
      }

      if (!responseSave) console.error("Ocurrion un error al guardar los detalles de la cita");

      this.processList.push({ text:"Detalles guardados", value: responseSave });
    },


    async crearAtencionMedica(citaId) {

      const query = `
        mutation CrearConsultaAtencionCitaMedica(
          $citaId       : Int!, 
          $especialidad : Int, 
          $tipoConsulta : Int, 
          $catmed       : Int, 
          $estadoRev    : String
        ) {
          crearConsultaAtencionCitaMedica(
            citaId             : $citaId, 
            tipoEspecialidadId : $especialidad, 
            tipoConsultaId     : $tipoConsulta, 
            catmedId           : $catmed, 
            estadoRev          : $estadoRev
          ) {
            consultaCitaMedica {
              id
              token
            }
          }
        }
      `;

      const variables = {
        citaId: parseInt(citaId, 10),
        especialidad : null,
        tipoConsulta : 1,
        catmed       : null,
        estadoRev    : null,
      };

      const responseConsulta = await axios.post(rutas.axios + "api", { query, variables });

      return responseConsulta.data.data.crearConsultaAtencionCitaMedica.consultaCitaMedica.token;
    },



    async crearOtrosServicios(citaId){

      if (!citaId) return;

      let tokenAtencionOfCita = null;

      if (this.tokenCita){
        const responseAtencion = await citasService.getAtencion(this.tokenCita);
        tokenAtencionOfCita = responseAtencion[0].token || null;

        if (!tokenAtencionOfCita) return;
      }


      const tokenAtencion = this.tokenCita
        ? tokenAtencionOfCita
        : await this.crearAtencionMedica(citaId);

      if(citaId && this.tipoServicio.includes('2')) await this.crearEnvioImagen(tokenAtencion);

      // crear envio laboratorios
      if(citaId && this.tipoServicio.includes('3')) await this.crearEnvioLaboratorio(tokenAtencion);

      // crear envio procedimientos
      if(citaId && this.tipoServicio.includes('4')) await this.crearEnvioProcedimientos(tokenAtencion);

      // crear la derivacion
      if(citaId  && this.esContraReferencia) await this.createDerivacion(tokenAtencion);
    },


    async crearEnvioImagen(tokenAtencion) {


      const dataEnvioImagenes = this.stDataEnvioImagenes;

      const mergeNumeroPieza = (texto = "", numeroPieza) => {
        const base = (texto || "").replace(/,?\s*Numero de Pieza:.*$/i, "").trim();
        const numero = (numeroPieza ?? "").toString().trim();
        if (!numero) return base;
        const sep = base ? ", " : "";
        return `${base}${sep}Numero de Pieza: ${numero}`;
      };

      const imagenesMap = dataEnvioImagenes.map( d => ({
        action          : d.action,
        imagenId        : d.imagen?.value,
        numeroOrden     : d.numeroOrden,
        lateralidad     : d.lateralidad.value,
        numeroPieza     : d.numeroPieza,
        motivoSolicitud : mergeNumeroPieza(d.motivoSolicitud, d.numeroPieza),
        resumenClinico  : mergeNumeroPieza(d.resumenClinico, d.numeroPieza),
        sedacion        : d.sedacion,
        justificacion   : d.justificacion,
        idRegistro      : d?.idRegistro
      }));

      const responseImages = await imagenesService.processEnvios(tokenAtencion, imagenesMap);

      this.processList.push({ text:"Imagenes creadas", value: responseImages });
    },



    async crearEnvioLaboratorio(tokenAtencion){

      const dataEnvioLaboratorios = this.stDataEnvioLaboratorios;
      const dataEnvioLabs400      = this.stDataEnvioLabs400;

      // registrar auxiliares
      if(this.stDataCita.cobertura !== '1' && dataEnvioLaboratorios?.length){
        const dataLabMapped = dataEnvioLaboratorios.map(
          d => {

            const { estadoLaboratorio, ...rest } = d;

            return {
              ...rest,
              atencionMedica: tokenAtencion,
              laboratorios  : JSON.stringify(d.laboratorios)
            }
          }
        )
        
        const registerAuxiliares = await labAuxiliarService.saveLaboratorios(dataLabMapped);
        this.processList.push({ text:"Examenes Registrados", value: registerAuxiliares });
      }


      if(this.stDataCita.cobertura === '1' && dataEnvioLabs400?.length){
        
        const dataLabMapped = dataEnvioLabs400.map(
          d => {
            const { estadoLaboratorio, ...rest } = d;

            return {
              // ...rest,
              accion        : d.accion,
              tokenAtencion : tokenAtencion,
              examenes      : d.laboratorios.map( l => l.value ).join(','),
              numeroOrden   : d.codigoOrden,
              justificacion : d.justificacion,
              estudioLab    : d.estudioLab,
              idRegistro    : d.idRegistro
            }
          }
        )

        const register400 = await labAs400Service.saveLaboratorios(dataLabMapped);
        // this.processList.push({ text:"Examenes Registrados", value: register400 });
      }
    },


    async crearEnvioProcedimientos(tokenAtencion){

      const dataEnvioProcedimientos = this.stDataEnvioProcedimientos;

      const envioProcedimientosMap = dataEnvioProcedimientos.map( d => ({
        action          : d.action,
        procedimientoId : d.procedimiento?.value,
        numeroOrden     : d.numeroOrden,
        motivoSolicitud : d.motivoSolicitud,
        resumenClinico  : d.resumenClinico,
        justificacion   : d.justificacion,
        idRegistro      : d?.idRegistro
      }));

      const responseSave = await procedimientosService.processEnvios(tokenAtencion, envioProcedimientosMap);

      this.processList.push({ text:"Procedimientos Guardados", value: responseSave });
    },


    async updateDocsPersonas() {
      const docsPersonas = this.stDataDocumentos.personas;

      if (!docsPersonas.length) return;

      const docsPersonasActualizados = await Promise.all(

        docsPersonas.map(async p => {


          let newUrlIdentificacion = null;
          let newUrlCarnetIssfa    = null;
          let newUrlCarnetIsspol   = null;

          if(p.cedulaFile){
            newUrlIdentificacion =  await fileService.upload(
              'cedulas', 
              p.cedulaFile, 
              p.identificacion, 
              p.urlIdentificacion
            );
          }

          if(p.carnetIssfa){
            newUrlCarnetIssfa =  await fileService.upload(
              'carnetIssfa', 
              p.carnetIssfa, 
              p.identificacion, 
              p.urlCarnetIssfa
            );
          }


          if(p.carnetIsspol){
            newUrlCarnetIsspol =  await fileService.upload(
              'carnetIsspol', 
              p.carnetIsspol, 
              p.identificacion, 
              p.urlCarnetIsspol
            );
          }

          // eliminar
          if(p.cedulaFile === undefined){
            const deleteCedula = await fileService.deleteFile(p?.urlIdentificacion);
            newUrlIdentificacion = deleteCedula ? 'eliminado' : '';
          }

          if(p.carnetIssfa === undefined){
            const deleteCarnetIssfa = await fileService.deleteFile(p?.urlCarnetIssfa);
            newUrlCarnetIssfa = deleteCarnetIssfa ? 'eliminado' : '';
          }

          if(p.carnetIsspol === undefined){
            const deleteCarnetIsspol = await fileService.deleteFile(p?.urlCarnetIsspol);
            newUrlCarnetIsspol = deleteCarnetIsspol ? 'eliminado' : '';
          }

          const fieldsToUpdate = {
            urlIdentificacion: newUrlIdentificacion,
            urlCarnetIssfa   : newUrlCarnetIssfa,
            urlCarnetIsspol  : newUrlCarnetIsspol,
          };

          const responseUpdate = await personasService.updateByToken(p.tokenPersona, fieldsToUpdate);
          return responseUpdate;
        })
      );

      this.processList.push({
        text: "Documentos actualizados",
        value: docsPersonasActualizados,
      });
    },


    async updateHistoriaClinica(){

      const numHistoriaClinica = this.stDataSeguro?.historiaClinica;
      if(!numHistoriaClinica) return;

      const tokenPaciente         = this.stDataCita?.paciente?.token;
      const historiaClinicaString = this.stDataCita?.paciente?.numHistoriaClinica;

      if(!tokenPaciente || !historiaClinicaString) {
        console.error('no hay token para actualizar historia clinica');
        return;
      }

      const historiaClinicaObj    = JSON.parse(historiaClinicaString);
      const establecimiento       = getEstablecimientoLS();
      
      historiaClinicaObj[establecimiento.id] = this.stDataSeguro?.historiaClinica;

      const historiaClinicaToSave = historiaClinicaObj && JSON.stringify(historiaClinicaObj);
      const params = { numHistoriaClinica: historiaClinicaToSave }

      const responseUpdate = await pacientesService.updateByToken(tokenPaciente, params);

      this.processList.push({
        text: "Historia Clinica actualizada",
        value: responseUpdate,
      });
    },


    async createDerivacion(tokenAtencion){

      // valida al editar si ya existe una derivacion creada
      if(this.esEditar){
        const responseDerivaciones = await derivacionesService.getAll({ tokenCita: this.tokenCita });
        if(responseDerivaciones?.derivaciones.length) return;
      }

      const establecimiento = getEstablecimientoLS();
      let nivelDerivacion = null;

      if (['1', '3', '4'].includes(establecimiento.id)) 
        nivelDerivacion = '1';

      if (['2', '5', '6'].includes(establecimiento.id)) 
        nivelDerivacion = '2';


      const tipoAtencion = this.tipoServicio?.includes('2')
        ? '3' // 3 es imagen 
        : this.tipoServicio?.includes('3')
          ? '2' // 2 es lab
          : this.tipoServicio?.includes('4')
            ? '4' 
            : null;

      if(!nivelDerivacion || !tipoAtencion) return;


      const tipoDerivacion = '3';
      
      const params = {
        tokenAtencion   : tokenAtencion,
        nivelDerivacion : nivelDerivacion,
        fechaDerivacion : this.stDataCita.fechaCita,
        tipoAtencion    : tipoAtencion,
        tipoDerivacion  : tipoDerivacion,
        diagnosticos    : ''
      }

      const derivacionResponse = await derivacionesService.registrar(params);

      this.processList.push({
        text: "Derivacion creada",
        value: derivacionResponse,
      })

    },

    validateKey(event) {
      const validKeys = ['1', '2', '3', '4'];
      const controlKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

      if ( !validKeys.includes(event.key) && !controlKeys.includes(event.key) ) {
        event.preventDefault();
      }

      if (this.encuesta?.length >= 1 && validKeys.includes(event.key)) {
        event.preventDefault();
      }
    },


    setToken() {
      const user = JSON.parse(localStorage.getItem("usuario"));
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`;
    },


    loadRespaldoCita(){
      const dataInLS = localStorage.getItem("respaldoCita");
      const dataObj = JSON.parse(dataInLS);

      if(dataObj) this.stDataCita = dataObj.dataCita

      this.flagLoadRespaldo = true;
    },

    getHoy() {
      const hoy = new Date();
      const yyyy = hoy.getFullYear();
      const mm = String(hoy.getMonth() + 1).padStart(2, '0');
      const dd = String(hoy.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },

  },

  
  computed: {

    ...mapState({
      stDataCita                : state => state.citas?.ingresoCitas?.dataInfoCita,
      stDataSeguro              : state => state.citas?.ingresoCitas?.dataSeguro,
      stDataTitulares           : state => state.citas?.ingresoCitas?.dataTitulares,
      stDataDocumentos          : state => state.citas?.ingresoCitas?.dataDocumentos,
      stDataEnvioImagenes       : state => state.citas?.ingresoCitas?.dataEnvioImagenes,
      stDataEnvioLaboratorios   : state => state.citas?.ingresoCitas?.dataEnvioLaboratorios,
      stDataEnvioLabs400        : state => state.citas?.ingresoCitas?.dataEnvioLabs400,
      stDataEnvioProcedimientos : state => state.citas?.ingresoCitas?.dataEnvioProcesos,

      stDocsMsps             : state => state.docsMsps.files,
      stDocsIdentificaciones : state => state.docsMsps.filesIdentificaciones,
    }),


    canSendImagenes(){
      return this.tipoServicio.includes('2')
    },

    canSendLaboratorios(){
      return this.tipoServicio.includes('3')
    },

    canSendProcedimientos(){
      return this.tipoServicio.includes('4')
    },

    canUpdateFechaCita(){
      if(!this.tokenCita) return false;
      return this.usuarioRoles.some(rol => ALLOWED_ROLES_EDIT_FECHA.includes(rol?.codigo));
    },


    canViewTabServicios(){
      return this.stDataCita?.grupoServicios === '2'
    },

    canViewTabSeguros(){
      const tipoCobertura = this.stDataCita?.cobertura;
      const coberturaCorrecta = tipoCobertura && tipoCobertura < 4;
      return coberturaCorrecta
    },

    tipoServicio(){
      let tipoServicio = this.stDataCita?.tipoServicios;
      if(!Array.isArray(tipoServicio)) tipoServicio = [tipoServicio]
      return tipoServicio
    },


    esOtrosServicios(){
      return ['2', '3', '4'].some(s => this.tipoServicio?.includes(s))
    },

    esContraReferencia(){
      const esDerivacion       = this.stDataCita?.esDerivado
      const esContraReferencia = this.stDataCita?.esContrareferencia
      return esDerivacion && esContraReferencia
    },

    tokenCita(){
      return this.$route.params.token
    },

    esEditar(){
      return this.$route.params.token
    },

    esCoberturaIess(){
      return this.stDataCita?.cobertura === '1'
    },

    esMenorDeEdad(){
      const fechaHoy = this.getHoy();
      const fechaNacimiento = this.stDataCita?.paciente?.persona?.fechaNacimiento
      const fechaCita = this.esEditar ? this.stDataCita?.fechaCita : fechaHoy

      return calculateAgeWithDateString(fechaNacimiento, fechaCita) < 18
    }

    
  },

  watch: {

    tipoServicio: {
      handler(){
        this.verTabEncuesta = false

        if(!this.tokenCita)
          setTimeout(() => { this.verTabEncuesta = true }, 100)
      }
    },


  },
};
</script>
